/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Deal_FallbackInputs */

const cs_page_title_deal_fallback = /** @type {(inputs: Page_Title_Deal_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod`)
};

const en_page_title_deal_fallback = /** @type {(inputs: Page_Title_Deal_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal`)
};

/**
* | output |
* | --- |
* | "Deal" |
*
* @param {Page_Title_Deal_FallbackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const page_title_deal_fallback = /** @type {((inputs?: Page_Title_Deal_FallbackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Deal_FallbackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page_title_deal_fallback(inputs)
	return cs_page_title_deal_fallback(inputs)
});